import { isMatch } from 'lodash'
import Vue from 'vue'

export const checkAuthFor = (user: any, rules: any[]): boolean => {
  return rules.some((rule: any) => {
    if (rule.userMatches) {
      return isMatch(user, rule.userMatches)
    } else if (rule.isSignedIn) {
      return !!user
    } else {
      throw new Error('rule must have userMatches or isSignedIn')
    }
  })
}

export default Vue.extend({
  created() {
    this.recheckAuthorization()
  },
  computed: {
    currentUser(): any {
      return this.$store.getters.currentUser
    },
    currentCase(): any {
      return this.$store.getters.currentCase
    },
    currentInvolvement(): any {
      return this.$store.getters.currentInvolvement
    },
    isTherapist(): boolean {
      return !!this.currentInvolvement?.actsAsTherapist
    },
    isSupervisor(): boolean {
      return !!this.currentInvolvement?.actsAsSupervisor
    },
    isInterviewer(): boolean {
      return !!this.currentInvolvement?.actsAsInterviewer
    },
    isSupporter(): boolean {
      return !!this.currentInvolvement?.actsAsSupporter
    },
    isCoordinator(): boolean {
      return !!this.currentUser?.is_coordinator_account
    },
    isCounselor(): boolean {
      return !!this.currentInvolvement?.actsAsCounselor
    },
    hasInterviewerRole(): boolean {
      return !!this.currentUser?.is_interviewer_account || this.isCoordinator
    },
    hasStaffRole(): boolean {
      const user = this.currentUser
      return !!(
        user?.is_interviewer_account ||
        user?.is_therapist_account ||
        user?.is_supervisor_account ||
        user?.is_supporter_account ||
        user?.is_coordinator_account
      )
    },
    isPatient(): boolean {
      return !!this.currentInvolvement?.actsAsPatient
    },
    requiresLogin(): boolean {
      const rules: any[] = this.$route.meta.authorizedIf || []
      return rules.some(rule => !!rule.isSignedIn)
    },
  },
  data() {
    return { isAuthorized: false }
  },
  methods: {
    recheckAuthorization() {
      const rules: any[] = this.$route.meta.authorizedIf || []
      this.isAuthorized = checkAuthFor(this.currentUser, rules)
    },
  },
  watch: {
    currentUser: {
      deep: true,
      handler(nowIs: any, was: any) {
        this.recheckAuthorization()
      },
    },
    $route(nowIs: any, was: any) {
      this.recheckAuthorization()
    },
  },
})
